module.exports = __webpack_public_path__ + "static/media/0004.56483324.jpg";